// components/Introduction.js
import React from 'react';

function Introduction() {
  return (
    <section className="about_section layout_padding-bottom">
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="detail-box">
              <div className="heading_container">
                <h2>About <span>Us</span></h2>
              </div>
              <p>
                MK AVANCO COMPANY LTD is a proudly Tanzanian transport and logistics company dedicated to understanding local challenges and delivering world-class fuel transportation solutions. Our deep roots in the region allow us to connect Tanzania with neighboring countries, including Kenya, Uganda, Rwanda, Burundi, Malawi, Zambia, and the Democratic Republic of Congo (DRC). We ensure safe, timely, and compliant fuel delivery, empowering industries, businesses, and communities across East and Central Africa.
                <br /><br />
                At MK Avanco, we are committed to ensuring that your cargo reaches its destination safely, promptly, and in excellent condition. Our robust network, experienced team, and modern fleet enable us to navigate the complexities of cross-border transportation, delivering consistent quality and reliability.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <div className="img-box">
              <iframe
                width="100%"
                height="315"
                src="https://www.youtube.com/embed/O2iokGAsHSs?rel=0&modestbranding=1&controls=1&showinfo=0"
                title="MK Avanco Introduction"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Introduction;